/**
* DevExpress Dashboard (_gauge.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { DataItemNumericFormat } from '../../../data-item/data-item-format';
import { floatFromModel, nullableFloatToModel } from '../../../metadata/_base-metadata';
import { kpiElementSerializationsInfo } from '../../kpi/metadata/_kpi-element';
export let minimum = { propertyName: 'minimum', modelName: '@Minimum', displayName: 'DashboardWebStringId.Gauge.Min', defaultVal: NaN, from: floatFromModel, toJsonObject: nullableFloatToModel };
export let maximum = { propertyName: 'maximum', modelName: '@Maximum', displayName: 'DashboardWebStringId.Gauge.Max', defaultVal: NaN, from: floatFromModel, toJsonObject: nullableFloatToModel };
export let scaleLabelNumericFormat = { propertyName: 'scaleLabelNumericFormat', modelName: 'ScaleLabelNumericFormat', displayName: 'DashboardWebStringId.TextBoxFormatText', type: DataItemNumericFormat };
export let gaugeSerializationsInfo = kpiElementSerializationsInfo.concat([minimum, maximum, scaleLabelNumericFormat]);
